module.exports = __webpack_public_path__ + "img/gifts_2.318e8190.jpeg";